import { useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import FormButton from '../../../Components/Buttons/FormButton';
import CustomizableTableForAddAndEdit from '../../../Components/Tables/CustomizableTableForAddAndEdit';
import { DataFromAPI, dropDownFromList, dropDownItemCode, dropDownToList, initialData, InvStatusList } from '../../../Data/testData';
import PageHeader from '../../../Layout/PageHeader';
import TransferItemFormStructure from '../../../Shared/Forms/TransferItemFormStructure';
import CustomPlaceholder, { customStyles } from '../../../Shared/Select/CustomPlaceholder';


// Custom Placeholder component


function TransferByItem() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const pageName = `Stock Transfer`;
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };



  const handleBack = () => {
    navigate("/inventory/stock-transfer")
  }

  const headerChildren = (
    <>
      <div className="d-flex align-items-center gap-1">
        <Dropdown>
          <Dropdown.Toggle
            className="btn bg-white text-dark dropdown-toggle"
            id="dropdown-basic"
          >
            Newest to oldest
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1" className="dropdown-toggle-item">
              Oldest to newest
            </Dropdown.Item>
            <Dropdown.Item href="#/action-2" className="dropdown-toggle-item">
              {" "}
              Newest to oldest
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );




  const columns = [
    { key: 'lineNumber', label: 'Line #', disable: true, customStyles: { textAlign: "center" as React.CSSProperties['textAlign'] }, customStyleForBody: { textAlign: "center" as React.CSSProperties['textAlign'] } },
    { key: 'itemCode', label: 'Item Code', inputType: <span className="customDropdown"><Select components={{ Placeholder: CustomPlaceholder }} styles={customStyles} options={dropDownItemCode} /> </span>, disable: true },
    { key: 'itemDescription', label: 'Item Description', disable: true },
    { key: 'uom', label: 'UOM', disable: true },
    { key: 'from', label: 'From', inputType: <span className="customDropdown"><Select options={dropDownFromList} /> </span> },
    { key: 'to', label: 'To', inputType: <span className="customDropdown"> <Select options={dropDownToList} /></span> },
    { key: 'transferQty', label: 'Transfer Qty', disable: true, customStyles: { textAlign: "center" as React.CSSProperties['textAlign'] }, customStyleForBody: { textAlign: "center" as React.CSSProperties['textAlign'] } },
    { key: 'invStatus', label: 'Inv Status', inputType: <span className="customDropdown"> <Select options={InvStatusList} /></span> },

  ];


  const inputs = [
    <>
      <label className="fw-bold">Transfer Date</label>
      <div className="mt-2">
        <input
          tabIndex={1}
          autoFocus={true}
          maxLength={50}
          type="date"
          name="transferDate"
          className="form-control"
          placeholder="Transfer Date"
        />
      </div>
    </>,
    <>
      <label className="fw-bold">From Inv Status</label>
      <div className="mt-2">
        <input
          tabIndex={2}
          maxLength={50}
          type="text"
          name="fromInvStatus"
          className="form-control"
          placeholder="Inventory Status"
        />
      </div>
    </>,
    <>
      <label className="fw-bold">To Inv Status</label>
      <div className="mt-2">
        <input
          tabIndex={3}
          maxLength={50}
          type="text"
          name="toInvStatus"
          className="form-control"
          placeholder="Enter To Inventory Status"
        />
      </div>
    </>,
    <>
      <label className="fw-bold">Custom Field 1</label>
      <div className="mt-2">
        <input
          tabIndex={4}
          maxLength={50}
          type="text"
          name="customField1"
          className="form-control"
          placeholder="Enter Custom Field 1"
        />
      </div>
    </>,
    <>
      <label className="fw-bold">Custom Field 2</label>
      <div className="mt-2">
        <input
          tabIndex={5}
          maxLength={50}
          type="text"
          name="customField2"
          className="form-control"
          placeholder="Enter Custom Field 2"
        />
      </div>
    </>,
  ];

  return (
    <>
      <PageHeader
        addUrl="/inbound/asn/overview/add"
        listUrl="/inventory/stock-transfer"
        viewType={true}
        isHistoryEnabled={true}
      // historyData={[historyData]}

      />


      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2">

        <TransferItemFormStructure inputFields={inputs} />

      </div>
      <div className="my-2 bg-white rounded p-4 CustomizedTable">

        <CustomizableTableForAddAndEdit columns={columns} initialData={initialData} dataFromAPI={DataFromAPI} filterColumn="itemCode" />
      </div>
      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton tabIndex={25} className="sph-btn me-4" handleClick={() => handleBack()}>
            Submit
          </FormButton>
          <FormButton tabIndex={26} className="sph-btn sph-shift me-4" handleClick={() => handleBack()}>
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  )
}

export default TransferByItem
